import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Store } from '@ngxs/store';

import { AuthState } from '@data/state';
import { ApplicationRoleType } from '@data/enum';

type AuthGuardOptions = {
    requiresAuthentication: boolean;
    allowedRoles?: ApplicationRoleType[];
};

const defaultOptions = (): AuthGuardOptions => ({
    requiresAuthentication: true,
    allowedRoles: [],
});

export const authGuard = (options: AuthGuardOptions = defaultOptions()): CanMatchFn => {
    return (_: Route, segments: UrlSegment[]) => {
        const router = inject(Router);
        const store = inject(Store);

        const isAuthenticated = store.selectSnapshot(AuthState.isAuthenticated);
        const roleType = store.selectSnapshot(AuthState.roleType);

        if (options.requiresAuthentication) {
            if (!isAuthenticated) {
                return router.createUrlTree(['/auth/login'], {
                    queryParams: { returnUrl: segments.map((s) => s.path).join('/') },
                });
            }

            // Role check — admin-only by default
            const allowedRoles = options.allowedRoles ?? [];
            if (allowedRoles.length > 0 && !allowedRoles.includes(roleType as ApplicationRoleType)) {
                return router.createUrlTree(['/auth/login']);
            }

            return true;
        }

        // Guest-only route (login page etc.)
        if (isAuthenticated) {
            return router.createUrlTree(['/dashboard']);
        }

        return true;
    };
};
